import { V3dTools } from '@/v3d/common';
import { iApp } from '@/Interfaces/app';
import { Camera } from './camera';
import { useConfigurationStore } from '@/Store/storeConfiguration';
import { useUIOnlyStore } from '@/Store/storeUI';
import { Room } from '@/Engine/Room';
import { Wardrobe } from '@/Engine/Wardrobe/Wardrobe';
import { demoRoom } from '@/Constants/demo';
import { loader } from '@/Engine/loader';
import { IV3D } from '@/Interfaces/v3d';
import {
    eventLimitClearTime, lineArrowUrl, textFrameUrl,
    windowModelUrl,
} from '@/Constants/common';
import {
    gridDivisions,
    gridEnabled,
    gridSize } from '@/Constants/3dConfig';
import { SelectionBox } from '@/Engine/SelectionBox';
import { useStoreData } from '@/Store/storeData';
import {
    SceneObjects, Shelf,
    storeConfigurationState,
} from '@/Interfaces/common';
import { RackModule } from '@/Engine/Wardrobe/RackModule';
import { _checkAllCollision, _checkCollision, _checkGroupCollision } from '@/Engine/checkCollision';
import { onStorageConfiguratorUpdate, updatePositionsUI } from '@/Engine/eventHandlers/onStorageConfiguratorUpdate';
import { $ } from '@/Engine/state';
import { loadDecorModel } from '@/Engine/decorModelLoader';
import { onPointerMove } from '@/Engine/eventHandlers/onPointerMove';
import { onDownHandler } from '@/Engine/eventHandlers/onDownHandler';
import { onPointerUpHandler } from '@/Engine/eventHandlers/onPointerUpHandler';
import { onDragOverHandler } from '@/Engine/eventHandlers/onDragOverHandler';
import { onDropHandler } from '@/Engine/eventHandlers/onDropHandler';
import { calculateAppWideProgress } from '@/utils/calculateAppWideProgress';
import { EventBus } from '@/utils/eventBus';
import { SelectionBoxForBox } from '@/Engine/SelectionBoxForBox';
import packageJson from '../../package.json';
import { BasicShadowMap } from 'three/src/constants';

declare let v3d: IV3D;
export const app = async function(app: iApp) {
    $.app = app;
    $.sceneBackGround = app.scene.background;
    app.hideFPS();
    app.disableRendering(0);
    const configuratorStore = useConfigurationStore();
    // app.render();
    const render = (cb?: () => void) => requestAnimationFrame(() => {
        if ($.pauseRender) return;
        app.render();
        if (cb) cb();
    });

    $.render = render;
    const v3dTools = new V3dTools(app);
    $.v3dTools = v3dTools;

    // const vergeConfig = useVergeConfig();

    const UIOnlyStore = useUIOnlyStore();

    // Интервал для ограничения количества евентов за 50мс
    const interval = setInterval(() => {
        $.eventsNum = 0;
    }, eventLimitClearTime);


    app.renderer.shadowMap.type = BasicShadowMap;
    // app.renderer.shadowMap.enabled = false;
    // app.renderer.shadowMap.autoUpdate = false;
    // app.renderer.shadowMap.needsUpdate = false;
    await loader('wardrobe.gltf.xz?' + packageJson.version + '.xz', (scene) => {
            scene.children.forEach((item) => {
                item.visible = false;
                item.receiveShadow = false;
                item.castShadow = false;
            });
        }, (progress) => {
            EventBus.emit('update-progress', calculateAppWideProgress('#process2#', progress));
            UIOnlyStore.setLoadProgress(progress);
        },
        app,
    );

    await loader(windowModelUrl, (scene) => {
            scene.children.forEach((item) => {
                item.visible = false;
            });
        }, (progress) => {
            EventBus.emit('update-progress', calculateAppWideProgress('#process3#', progress));
            UIOnlyStore.setLoadProgress(progress);
        },
        app,
    );

    await loader(textFrameUrl, (scene) => {
            scene.children.forEach((item) => {
                // item.visible = false;
            });
            $.selectionBox = new SelectionBox();
            $.selectionBoxForBox = new SelectionBoxForBox();
            app.scene.add($.selectionBox.model);
            app.scene.add($.selectionBoxForBox.model);
        }, (progress) => {
            // EventBus.emit('update-progress', calculateAppWideProgress('#process3#', progress));
            // UIOnlyStore.setLoadProgress(progress);
        },
        app,
    );

    await loader(lineArrowUrl, (scene) => {
            scene.children.forEach((item) => {
                // item.visible = false;
            });
        }, (progress) => {
            // EventBus.emit('update-progress', calculateAppWideProgress('#process3#', progress));
            // UIOnlyStore.setLoadProgress(progress);
        },
        app,
    );

    $.room = new Room(v3dTools);
    const camera = new Camera(app.getCamera(), v3dTools, $.room, app);
    $.camera = camera;
    app.scene.add($.room.model);

    $.wardrobe = new Wardrobe($.room, v3dTools);

    if (gridEnabled)
        app.scene.add(new v3d.GridHelper(gridSize, gridDivisions));


    const switchMode = (mode: number) => {
        if (mode === 1 || mode === 0) {
            camera.topCamMode();
            app.controls.enablePan = true;
            app.controls.enableKeys = false;
            app.controls.enableRotate = false;
            $.room.switchCeil('enable');
        } else {
            app.controls.enableRotate = true;
            app.controls.enablePan = true;
            app.controls.enableKeys = true;
            $.room.switchCeil('disable');
            camera.standardCamMode();
        }
    };

    UIOnlyStore.$subscribe((mutation, state) => {
        if ($.isDecoration !== state.isDecoration) {
            $.isDecoration = state.isDecoration;
            switchDecoration();
            $.render();
        }
        if ($.isRuler !== state.isRuler) {
            $.isRuler = state.isRuler;
            $.selectionBox?.update();
            $.selectionBoxForBox?.update();
            $.wardrobe.shelves.forEach(shelf => {
                shelf.addRuler();
            });
            $.wardrobe.rackModules.forEach(shelf => {
                shelf.addRuler();
            });
            $.render();
        }

        if ($.mode !== state.mode) {
            $.mode = state.mode;
            switchMode(state.mode);
        }
    });

    configuratorStore.$subscribe(async(mutation: any, state: storeConfigurationState) => {
        if (state.room.selectedRoomType !== $.selectedRoomType) {
            $.selectedRoomType = state.room.selectedRoomType;
            loadDecorModel(useStoreData().getModelledDecorsOfSelectedRoom);
        }
        await onStorageConfiguratorUpdate(state);
        switchDecoration();
        $.selectionBox.update();
        $.selectionBoxForBox.update();
        $.render();
    });

    configuratorStore.setRoom(demoRoom);

    const checkCollision = (object: SceneObjects, side: string, excludeUUIDs = []): any => {
        return _checkCollision(object,
            [ ...$.wardrobe.shelves, ...$.windows, ...$.doors, ...$.room.getObb(side), ...$.boxes ]
                .filter((item)=>!excludeUUIDs.includes(item.uuid)),
        );
    };

    const checkShelfCollision = (object: SceneObjects, side: string): any => {
        return _checkCollision(object, [ ...$.wardrobe.shelves, ...$.windows, ...$.doors, ...$.room.getObb(side), ...$.boxes ]);
    };

    const checkShelfCollisionWithExclude = (object: SceneObjects, side: string, excludeUUIDs: string[]): any => {
        return _checkCollision(object,
            [ ...$.wardrobe.shelves, ...$.windows, ...$.doors, ...$.room.getObb(side), ...$.boxes ]
                .filter((item)=>!excludeUUIDs.includes(item.uuid)),
        );
    };

    const checkAllShelfCollisionWithExclude = (object: SceneObjects, side: string, excludeUUIDs: string[]): any => {
        return _checkAllCollision(object,
            [ ...$.wardrobe.shelves, ...$.windows, ...$.doors, ...$.room.getObb(side), ...$.boxes ]
                .filter((item)=>!excludeUUIDs.includes(item.uuid)),
        );
    };

    const checkCollisionWithRack = (object: SceneObjects, side: string, excludeUUIDs: string[]) => {
        return _checkCollision(object,
            [
                ...$.wardrobe.rackModules.map((rack)=> rack.rackLeft),
                ...$.wardrobe.rackModules.map((rack)=>rack.rackRight),
                ...$.wardrobe.rackModules.map((rack)=> rack.rackLeft2),
                ...$.wardrobe.rackModules.map((rack)=> rack.rackRight2),
            ]
                .filter((item)=>item)
                .filter((item)=>!excludeUUIDs.includes(item.uuid)),
        );
    };

    const checkGroupCollision = (selectionBox: SelectionBox, sourceObjects: Array<RackModule | Shelf>, side: string) => {
        const sourceObjUUIDs = sourceObjects.map((item)=>item.uuid);
        const objects = [ ...$.wardrobe.shelves, ...$.windows, ...$.doors, ...$.room.getObb(side) ]
            .filter((item)=>!sourceObjUUIDs.includes(item.uuid));
        return _checkGroupCollision(selectionBox, objects);
    };

    $.checkCollision = checkCollision;
    $.checkShelfCollisionWithExclude = checkShelfCollisionWithExclude;
    $.checkShelfCollision = checkShelfCollision;
    $.checkGroupCollision = checkGroupCollision;
    $.checkCollisionWithRack = checkCollisionWithRack;
    $.checkAllShelfCollisionWithExclude = checkAllShelfCollisionWithExclude;

    const containerParent = document.getElementById('v3d-container') as HTMLElement;
   $.container = containerParent;

    const switchDecoration = () => {
        if ($.isDecoration) {
            $.wardrobe.addDecor($.decorModelsBySurface);
        } else {
            $.wardrobe.removeDecor();
        }

    };

    camera.topCamMode(true);
    switchMode(UIOnlyStore.mode);
    setTimeout(()=>{
        updatePositionsUI();
    }, 100);
    document.addEventListener('keyup', (e)=>{
        if (e.key === 'Escape') {
            $.selectionBox.unselect();
            $.selectionBoxForBox.unselect();
            $.render();
        }
    });
    $.container.addEventListener('pointermove', onPointerMove);
    $.container.addEventListener('pointerdown', onDownHandler);
    $.container.addEventListener('pointerup', onPointerUpHandler);
    $.container.addEventListener('drop', onDropHandler);
    $.container.addEventListener('dragover', onDragOverHandler);
    window.addEventListener('resize', ()=>{
        updatePositionsUI();
        $.render();
    });
    app.controls.addEventListener('change', ()=>{
        if ($.room.oneWall)
            return;

        const camY = $.app.camera.rotation.y;
        const camX = $.app.camera.rotation.x;

        $.room.enableAllWalls();

        if (camY > 0.17) {
            $.room.hideWall('right');
            // $.room.walls.right.plane.removeFromParent();
            // $.room.walls.right.model?.removeFromParent();
        }
        if (camY < -0.17) {
            $.room.hideWall('left');

            // $.room.walls.left.plane.removeFromParent();
            // $.room.walls.left.model?.removeFromParent();
        }
        if (camY < 1.36 && camY > -1.36 && camX < -1.6) {
            $.room.hideWall('front');
            // $.room.walls.front.plane.removeFromParent();
            // $.room.walls.front.model?.removeFromParent();
        }
        if (camY < 1.36 && camY > -1.36 && camX > -1.3) {
            $.room.hideWall('back');
            // $.room.walls.back.plane.removeFromParent();
            // $.room.walls.back.model?.removeFromParent();
        }
        // if (cam)

        $.render(()=>{
            updatePositionsUI();
            // const distances = room.decorWalls.map((wall)=>wall.position.distanceTo(camera.camera.position));
            // const min = Math.min(...distances);
            // const nearestWallIndex = distances.indexOf(min);
            // room.decorWalls[nearestWallIndex].visibile = false;

        });
    });

    $.render();
    UIOnlyStore.setIs3dLoaded();

    loadDecorModel(useStoreData().getModelledDecorsOfSelectedRoom);
};
